export default "__VITE_ASSET__Dw_wJoh0__"